(function () {
  const viewTransitionRenderBlocker = document.getElementById("view-transition-render-blocker");

  // Release the render-block immediately on blog pages (no transition happens there
  // anyway, so there's no reason to hold first paint hostage for up to 1.8s).
  if (
    window.matchMedia("(prefers-reduced-motion: reduce)").matches ||
    isLowPowerDevice() ||
    isBlogPath(location.pathname)
  ) {
    viewTransitionRenderBlocker?.remove();
  } else {
    const RENDER_BLOCKER_TIMEOUT_MS = Math.max(0, 1800 - performance.now());
    setTimeout(() => {
      viewTransitionRenderBlocker?.remove();
    }, RENDER_BLOCKER_TIMEOUT_MS);
  }

  const idleCallback = typeof requestIdleCallback === "function" ? requestIdleCallback : setTimeout;

  window.addEventListener("pageswap", async (event) => {
    const { viewTransition } = event;
    if (shouldSkipViewTransition(viewTransition, event)) {
      viewTransition?.skipTransition();
      return;
    }
    ["pointerdown", "keydown"].forEach((eventName) => {
      document.addEventListener(eventName, () => { viewTransition.skipTransition(); }, { once: true });
    });
    document.querySelectorAll('[data-view-transition-type]:not([data-view-transition-triggered])').forEach((element) => {
      element.removeAttribute("data-view-transition-type");
    });
    const transitionType = document.querySelector('[data-view-transition-triggered]')?.getAttribute("data-view-transition-type");
    if (transitionType) {
      viewTransition.types.clear();
      viewTransition.types.add(transitionType);
      sessionStorage.setItem("custom-transition-type", transitionType);
    } else {
      viewTransition.types.clear();
      viewTransition.types.add("page-navigation");
      sessionStorage.removeItem("custom-transition-type");
    }
  });

  window.addEventListener("pagereveal", async (event) => {
    const { viewTransition } = event;
    if (shouldSkipViewTransition(viewTransition, event)) {
      viewTransition?.skipTransition();
      return;
    }
    const customTransitionType = sessionStorage.getItem("custom-transition-type");
    if (customTransitionType) {
      viewTransition.types.clear();
      viewTransition.types.add(customTransitionType);
      await viewTransition.finished;
      viewTransition.types.clear();
      viewTransition.types.add("page-navigation");
      idleCallback(() => {
        sessionStorage.removeItem("custom-transition-type");
        document.querySelectorAll('[data-view-transition-type]').forEach((element) => {
          element.removeAttribute("data-view-transition-type");
        });
      });
    } else {
      viewTransition.types.clear();
      viewTransition.types.add("page-navigation");
    }
  });

  function shouldSkipViewTransition(viewTransition, event) {
    return !(viewTransition instanceof ViewTransition)
      || isLowPowerDevice()
      || prefersReducedMotion()
      || isBlogNavigation(event);
  }

  function isBlogNavigation(event) {
    try {
      if (isBlogPath(location.pathname)) return true;
      const activation = event?.activation;
      if (activation) {
        const fromPath = activation.from?.url ? new URL(activation.from.url).pathname : null;
        const toPath = activation.entry?.url ? new URL(activation.entry.url).pathname : null;
        if (isBlogPath(fromPath) || isBlogPath(toPath)) return true;
      }
    } catch (e) {}
    return false;
  }

  function isBlogPath(pathname) {
    return !!pathname && pathname.indexOf("/blogs/") !== -1;
  }

  function prefersReducedMotion() {
    return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  }

  function isLowPowerDevice() {
    return Number(navigator.hardwareConcurrency) <= 2 || Number(navigator.deviceMemory) <= 2;
  }
})();